'use client';

import { useContext, useMemo, type FC } from 'react';
import type { NotesButtonProps } from './NotesButton.types';
import { Button, Tooltip, Text } from '@/_components';
import { ClientQuestionnaireContext } from '@/_contexts/client/ClientQuestionnaireProvider';
import { PreviewContext } from '@/_contexts/PreviewProvider';

export const NotesButton: FC<NotesButtonProps> = ({
  question,
  isDisabled,
  mode,
}) => {
  const { setSelectedQuestion } = useContext(ClientQuestionnaireContext);
  const { setSelectedPreviewQuestion } = useContext(PreviewContext);

  const onQuestionSelect = () => {
    if (mode === 'admin-preview') return setSelectedPreviewQuestion(question);
    if (mode === 'admin-template') return;

    return setSelectedQuestion(question);
  };

  const commentCount: number = useMemo(() => {
    return (
      question?.filtered_questionnaire_comments?.filter((x) => !x.removed)
        ?.length ?? 0
    );
  }, [question?.filtered_questionnaire_comments]);

  const noteCountCopy: string = commentCount > 1 ? 'View Notes' : 'View Note';

  return (
    <Tooltip isDisabled={!isDisabled}>
      <Tooltip.Content>
        <Text color="currentcolor" type="small">
          Questionnaire is locked
        </Text>
      </Tooltip.Content>
      <Tooltip.Trigger>
        <Button
          value={!!commentCount ? noteCountCopy : 'Add Note'}
          count={commentCount}
          isDisabled={isDisabled || mode === 'admin-template'}
          intent="secondary"
          size="small"
          onClick={onQuestionSelect}
        />
      </Tooltip.Trigger>
    </Tooltip>
  );
};
